import { defineStore } from 'pinia'
import type {
    ICalculatorSelectedValues,
    ICalculatorSetting,
} from '~/types/calculator.types'
import type { Category } from '~/types/global.types'

export type PropsNameModal =
    | 'mobileMenu'
    | 'searchMenu'
    | 'video'
    | 'costSet'
    | 'calculate'
    | 'contactMenu'
    | 'feedbackModal'
    | 'modelsComparison'
    | 'searchModal'
    | 'successModal'

type ModalsType = {
    [key in PropsNameModal]: boolean
}
export const useModalStore = defineStore('modalStore', {
    state: () => ({
        modals: {
            mobileMenu: false,
            contactMenu: false,
            costSet: false,
            searchMenu: false,
            feedbackModal: false,
            successModal: false,
            calculate: false,
            video: false,
            modelsComparison: false,
        } as ModalsType,
        formID: 0,
        typeForm: '',
        nameForm: '',
        feedbackLabel: '',
        feedbackMessage: '',
        headerFeedbackLabel: '',
        hasOpenModal: false as boolean,
        videoLink: '' as string,
        nameProduct: '' as string,
        categories: [] as Category[],
        calculator: null as ICalculatorSetting | null,
        calculatorSelectedValues: {} as ICalculatorSelectedValues,
    }),
    actions: {
        open(name: PropsNameModal): void {
            this.modals[name] = true
            this.hasOpenModal = Object.values(this.modals).some(
                (value: boolean) => value
            )
        },
        close(name: PropsNameModal): void {
            this.modals[name] = false
            this.hasOpenModal = Object.values(this.modals).some(
                (value: boolean) => value
            )
            this.videoLink = ''
            this.formID = 0
            this.nameForm = ''
            this.feedbackMessage = ''
        },
        setVideoLink(link: string): void {
            this.videoLink = link
        },
        setFormID(id: number): void {
            this.formID = id
        },
        setFormName(name: string): void {
            this.nameForm = name
        },
        setFeedbackLabel(label: string): void {
            this.feedbackLabel = label
        },
        setFeedbackMessage(message: string): void {
            this.feedbackMessage = message
        },
        setHeaderFeedbackLabel(label: string): void {
            this.headerFeedbackLabel = label
        },
        setCategories(categories: Category[]) {
            this.categories = categories
        },
        setNameProduct(product: string): void {
            this.nameProduct = product
        },
        setCalulator(
            calculator: ICalculatorSetting,
            selectedValues: ICalculatorSelectedValues
        ): void {
            this.calculator = calculator
            this.calculatorSelectedValues = selectedValues
        },
    },
})
